import { useSearchParams } from "react-router-dom";

export default function ReceiveRequestFeedback() {
  const [searchParams] = useSearchParams();
  const title = searchParams.get("title");
  const description = searchParams.get("description");
  const description2 = searchParams.get("description2");

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="max-w-2xl mx-auto space-y-8 p-6 text-center bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-sans text-gray-800 font-light">
          Support Center
        </h1>
        <h2 className="text-xl md:text-3xl lg:text-4xl font-semibold text-blue-600">
          {title}
        </h2>
        <p className="text-gray-600 text-base md:text-lg">{description}</p>
        <p className="text-gray-600 text-base md:text-lg">{description2}</p>
      </div>
    </div>
  );
}
